module.exports = __webpack_public_path__ + "media/images/icons/circled-x-53d5329161e7f0f1c3dbce07a3a2c8bc.svg";